module.exports = __webpack_public_path__ + "static/media/400407_02.6eeb2359.png";